import { api } from "../api";

export async function destroy(id: number): Promise<number> {
  try {
    const { status } = await api.delete(`/user-notifications/${id}`);

    return status;
  } catch (err) {
    console.log(err);
    return 500;
  }
}
